<div>
    @for (column of columns(); track $index) {
        <web-navigation-column-item
            [entity]="column"
            [parentEntity]="entity()"
            [parentIndex]="index()"
            [selectedEntity]="selectedEntity()"
        />
    }
</div>
